import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_OlapCrossNavigationStepOne = _resolveComponent("OlapCrossNavigationStepOne")
  const _component_OlapCrossNavigationStepTwo = _resolveComponent("OlapCrossNavigationStepTwo")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "olap-cross-naviagtion-definition-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    style: _ctx.olapCrossNavigationDefinitionDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-2 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.olap.crossNavigationDefinition.title')), 1)
        ]),
        end: _withCtx(() => [
          (_ctx.step === 0)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                id: "olap-add-new-cross-navigation-button",
                class: "kn-button kn-button--primary",
                onClick: _ctx.addNewParameter
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.addNew')), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        onClick: _ctx.closeDialog
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.step === 0)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            class: "kn-button kn-button--primary",
            disabled: !_ctx.selectedParameter || !_ctx.selectedParameter.type,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.step = 1))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.next')), 1)
            ]),
            _: 1
          }, 8, ["disabled"]))
        : (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            class: "kn-button kn-button--primary",
            disabled: !_ctx.selectedParameter || !_ctx.selectedParameter.name,
            onClick: _ctx.save
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]))
    ]),
    default: _withCtx(() => [
      (_ctx.step === 0)
        ? (_openBlock(), _createBlock(_component_OlapCrossNavigationStepOne, {
            key: 0,
            propParameters: _ctx.parameters,
            addNewParameterVisible: _ctx.addNewParameterVisible,
            propSelectedParameter: _ctx.selectedParameter,
            onParameterSelected: _ctx.onParameterSelect,
            onDeleteParameter: _ctx.deleteParameter
          }, null, 8, ["propParameters", "addNewParameterVisible", "propSelectedParameter", "onParameterSelected", "onDeleteParameter"]))
        : (_openBlock(), _createBlock(_component_OlapCrossNavigationStepTwo, {
            key: 1,
            propSelectedParameter: _ctx.selectedParameter,
            cell: _ctx.cell,
            onSelectFromTable: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('selectFromTable', _ctx.selectedParameter?.type)))
          }, null, 8, ["propSelectedParameter", "cell"]))
    ]),
    _: 1
  }, 8, ["style", "visible"]))
}